// Archivo para centralizar la URL base de la API REST

const BASE_URL = 'http://51.83.46.40:3000/api';
export const API_BASE_URL = 'http://51.83.46.40:3000/api'; // API local (funcionando)
// export const API_BASE_URL = 'http://51.83.46.40:3000/api'; // API remota (comentada)

let sessionExpiredShown = false;

export async function apiFetch(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  const token = localStorage.getItem('token');
  options.headers = options.headers || {};
  if (token) {
    options.headers['Authorization'] = `Bearer ${token}`;
  }
  try {
    const response = await fetch(url, options);
    
    // Solo tratar como sesión expirada si NO es la ruta de login
    if (response.status === 401 && !sessionExpiredShown && !endpoint.includes('/login')) {
      sessionExpiredShown = true;
      localStorage.removeItem('token');
      localStorage.setItem('sessionExpired', 'true');
      alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
      window.location.href = '/login';
      return Promise.reject(new Error('Sesión expirada'));
    }
    
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
}

// ========== FUNCIONES API DE TALLERES ==========

// Consultar talleres disponibles
export async function consultarTalleres() {
  try {
    console.log('🎯 Consultando talleres disponibles...');
    
    try {
      // Intentar desde API
      const response = await apiFetch('/talleres/consultar');
      
      if (response.ok) {
        const resultado = await response.json();
        console.log('✅ Talleres desde API:', resultado);
        
        if (resultado.exito && resultado.data) {
          // Guardar en localStorage como cache
          localStorage.setItem('talleres_cache', JSON.stringify(resultado.data));
          
          return {
            exito: true,
            data: resultado.data,
            fuente: 'api'
          };
        }
      }
    } catch (apiError) {
      console.warn('⚠️ API de talleres no disponible:', apiError.message);
    }
    
    // Fallback a localStorage o datos por defecto
    console.log('📦 Usando talleres desde localStorage/datos por defecto...');
    
    let talleresLocal = JSON.parse(localStorage.getItem('talleres_cache') || '[]');
    
    // Si no hay talleres en localStorage, usar datos por defecto
    if (talleresLocal.length === 0) {
      talleresLocal = [
        {
          IdTaller: 10,
          Nombre: 'FÚTBOL',
          Descripcion: 'Entrenamiento de fútbol para todas las edades',
          Activo: true
        },
        {
          IdTaller: 11,
          Nombre: 'BALONCESTO',
          Descripcion: 'Práctica de baloncesto y técnicas básicas',
          Activo: true
        },
        {
          IdTaller: 12,
          Nombre: 'VOLEIBOL',
          Descripcion: 'Entrenamiento de voleibol en equipo',
          Activo: true
        }
      ];
      
      localStorage.setItem('talleres_cache', JSON.stringify(talleresLocal));
    }
    
    return {
      exito: true,
      data: talleresLocal,
      fuente: 'localStorage'
    };
    
  } catch (error) {
    console.error('❌ Error al consultar talleres:', error);
    return {
      exito: false,
      data: [],
      fuente: 'error',
      mensaje: error.message
    };
  }
}

// Obtener nombre de taller por ID
export function obtenerNombreTaller(idTaller) {
  try {
    const talleres = JSON.parse(localStorage.getItem('talleres_cache') || '[]');
    const taller = talleres.find(t => t.IdTaller == idTaller);
    return taller ? taller.Nombre : `Taller ${idTaller}`;
  } catch (error) {
    console.error('Error obteniendo nombre de taller:', error);
    return `Taller ${idTaller}`;
  }
}

// ========== FUNCIONES API DE ALUMNOS ==========

// Consultar alumnos disponibles
export async function consultarAlumnos(filtros = {}) {
  try {
    console.log('👥 Consultando alumnos...', filtros);
    
    try {
      // Intentar desde API
      const params = new URLSearchParams();
      if (filtros.idTaller) params.append('idTaller', filtros.idTaller);
      if (filtros.idGrupo) params.append('idGrupo', filtros.idGrupo);
      if (filtros.activo !== undefined) params.append('activo', filtros.activo);
      
      const queryString = params.toString();
      const endpoint = queryString ? `/alumnos/consultar?${queryString}` : '/alumnos/consultar';
      
      const response = await apiFetch(endpoint);
      
      if (response.ok) {
        const resultado = await response.json();
        console.log('✅ Alumnos desde API:', resultado);
        
        if (resultado.exito && resultado.data) {
          // Guardar en localStorage como cache
          const cacheKey = `alumnos_cache_${filtros.idTaller || 'all'}_${filtros.idGrupo || 'all'}`;
          localStorage.setItem(cacheKey, JSON.stringify(resultado.data));
          
          return {
            exito: true,
            data: resultado.data,
            fuente: 'api'
          };
        }
      }
    } catch (apiError) {
      console.warn('⚠️ API de alumnos no disponible:', apiError.message);
    }
    
    // Fallback a localStorage o datos por defecto
    console.log('📦 Usando alumnos desde localStorage/datos por defecto...');
    
    const cacheKey = `alumnos_cache_${filtros.idTaller || 'all'}_${filtros.idGrupo || 'all'}`;
    let alumnosLocal = JSON.parse(localStorage.getItem(cacheKey) || '[]');
    
    // Si no hay alumnos en localStorage, usar datos por defecto
    if (alumnosLocal.length === 0) {
      alumnosLocal = [
        {
          IdAlumno: 101,
          Nombres: 'Juan',
          Apellidos: 'Pérez',
          NombreCompleto: 'Juan Pérez',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 102,
          Nombres: 'María',
          Apellidos: 'García',
          NombreCompleto: 'María García',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 103,
          Nombres: 'Carlos',
          Apellidos: 'López',
          NombreCompleto: 'Carlos López',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 104,
          Nombres: 'Ana',
          Apellidos: 'Martínez',
          NombreCompleto: 'Ana Martínez',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 105,
          Nombres: 'Luis',
          Apellidos: 'Rodríguez',
          NombreCompleto: 'Luis Rodríguez',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 106,
          Nombres: 'Carmen',
          Apellidos: 'Silva',
          NombreCompleto: 'Carmen Silva',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 107,
          Nombres: 'José',
          Apellidos: 'González',
          NombreCompleto: 'José González',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 108,
          Nombres: 'Laura',
          Apellidos: 'Morales',
          NombreCompleto: 'Laura Morales',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 109,
          Nombres: 'Pedro',
          Apellidos: 'Ramírez',
          NombreCompleto: 'Pedro Ramírez',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        },
        {
          IdAlumno: 110,
          Nombres: 'Sofia',
          Apellidos: 'Herrera',
          NombreCompleto: 'Sofia Herrera',
          IdTaller: filtros.idTaller || 10,
          IdGrupo: filtros.idGrupo || 15,
          Activo: true
        }
      ];
      
      localStorage.setItem(cacheKey, JSON.stringify(alumnosLocal));
    }
    
    return {
      exito: true,
      data: alumnosLocal,
      fuente: 'localStorage'
    };
    
  } catch (error) {
    console.error('❌ Error al consultar alumnos:', error);
    return {
      exito: false,
      data: [],
      fuente: 'error',
      mensaje: error.message
    };
  }
}

// Obtener nombre de alumno por ID
export function obtenerNombreAlumno(idAlumno) {
  try {
    // Buscar en todos los caches de alumnos
    const keys = Object.keys(localStorage).filter(key => key.startsWith('alumnos_cache_'));
    
    for (const key of keys) {
      const alumnos = JSON.parse(localStorage.getItem(key) || '[]');
      const alumno = alumnos.find(a => a.IdAlumno == idAlumno);
      if (alumno) {
        return alumno.NombreCompleto || `${alumno.Nombres} ${alumno.Apellidos}`;
      }
    }
    
    // Fallback a nombres por defecto
    const nombresEjemplo = {
      101: 'Juan Pérez',
      102: 'María García', 
      103: 'Carlos López',
      104: 'Ana Martínez',
      105: 'Luis Rodríguez',
      106: 'Carmen Silva',
      107: 'José González',
      108: 'Laura Morales',
      109: 'Pedro Ramírez',
      110: 'Sofia Herrera'
    };
    
    return nombresEjemplo[idAlumno] || `Alumno ${idAlumno}`;
  } catch (error) {
    console.error('Error obteniendo nombre de alumno:', error);
    return `Alumno ${idAlumno}`;
  }
}

// ========== FUNCIONES API DE ASISTENCIA CON PERSISTENCIA LOCAL ==========

const ASISTENCIA_KEY = 'asistencias_guardadas';

// Obtener asistencias del localStorage
function obtenerAsistenciasLocal() {
  const data = localStorage.getItem(ASISTENCIA_KEY);
  return data ? JSON.parse(data) : [];
}

// Guardar asistencias en localStorage
function guardarAsistenciasLocal(asistencias) {
  localStorage.setItem(ASISTENCIA_KEY, JSON.stringify(asistencias));
}

// Guardar asistencia (con persistencia real y backup)
export async function guardarAsistencia(datosAsistencia) {
  try {
    console.log('💾 Guardando asistencia (API + localStorage):', datosAsistencia);
    
    // SIEMPRE guardar en localStorage como backup
    const asistenciasExistentes = obtenerAsistenciasLocal();
    
    // Crear registros para localStorage
    const nuevasAsistenciasLS = datosAsistencia.Asistencias.map((asist, index) => ({
      Id: Date.now() + index,
      IdTaller: datosAsistencia.IdTaller,
      IdGrupo: datosAsistencia.IdGrupo,
      IdAlumno: asist.IdAlumno,
      IdMaestro: datosAsistencia.IdMaestro,
      Fecha: datosAsistencia.Fecha,
      Estado: asist.Estado,
      Observaciones: asist.Observaciones || '',
      FechaRegistro: new Date().toISOString()
    }));
    
    // Filtrar asistencias existentes para esta fecha/grupo
    const filtradas = asistenciasExistentes.filter(a => 
      !(a.IdTaller == datosAsistencia.IdTaller && 
        a.IdGrupo == datosAsistencia.IdGrupo && 
        a.Fecha === datosAsistencia.Fecha)
    );
    
    const todasAsistenciasLS = [...filtradas, ...nuevasAsistenciasLS];
    guardarAsistenciasLocal(todasAsistenciasLS);
    
    console.log(`💾 Guardado en localStorage: ${nuevasAsistenciasLS.length} registros`);
    
    // Intentar guardar en API también
    try {
      const response = await apiFetch('/asistencia/guardar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datosAsistencia)
      });
      
      const resultado = await response.json();
      console.log('🌐 Guardado en API:', resultado);
      
      return {
        exito: true,
        mensaje: 'Asistencia guardada correctamente (API + localStorage)',
        data: { 
          AsistenciasGuardadas: nuevasAsistenciasLS.length,
          fuenteAPI: resultado.exito ? 'exitoso' : 'fallido',
          fuenteLocal: 'exitoso'
        }
      };
    } catch (apiError) {
      console.warn('⚠️ API falló, pero localStorage funcionó:', apiError.message);
      
      return {
        exito: true,
        mensaje: 'Asistencia guardada correctamente (localStorage backup)',
        data: { 
          AsistenciasGuardadas: nuevasAsistenciasLS.length,
          fuenteAPI: 'fallido',
          fuenteLocal: 'exitoso'
        }
      };
    }
  } catch (error) {
    console.error('Error al guardar asistencia:', error);
    throw error;
  }
}

// Consultar asistencia (API primero, localStorage como backup)
export async function consultarAsistencia(filtros = {}) {
  try {
    console.log('🔍 Consultando asistencia con filtros:', filtros);
    
    // 1. PRIMERO: Intentar consultar la API
    try {
      console.log('🌐 Consultando API de asistencia...');
      
      const params = new URLSearchParams();
      if (filtros.idTaller) params.append('idTaller', filtros.idTaller);
      if (filtros.idGrupo) params.append('idGrupo', filtros.idGrupo);
      if (filtros.fecha) params.append('fecha', filtros.fecha);
      if (filtros.idMaestro) params.append('idMaestro', filtros.idMaestro);
      if (filtros.idAlumno) params.append('idAlumno', filtros.idAlumno);
      if (filtros.estado) params.append('estado', filtros.estado);
      
      const queryString = params.toString();
      const endpoint = queryString ? `/asistencia/consultar?${queryString}` : '/asistencia/consultar';
      
      console.log('📡 Endpoint completo:', `${API_BASE_URL}${endpoint}`);
      console.log('📋 Parámetros enviados:', Object.fromEntries(params));
      
      const response = await apiFetch(endpoint);
      
      console.log('📥 Response status:', response.status);
      console.log('📥 Response headers:', response.headers);
      
      if (response.ok) {
        const resultado = await response.json();
        console.log('✅ API Response:', resultado);
        
        if (resultado.exito && resultado.data && Array.isArray(resultado.data)) {
          console.log(`✅ API devolvió ${resultado.data.length} registros`);
          
          // Si la API no tiene datos, intentar agregar algunos datos de ejemplo
          if (resultado.data.length === 0) {
            console.log('📝 API sin datos, intentando agregar ejemplos...');
            await crearDatosEjemplo();
            
            // Volver a consultar después de crear datos
            const responseSegunda = await apiFetch(endpoint);
            if (responseSegunda.ok) {
              const resultadoSegundo = await responseSegunda.json();
              if (resultadoSegundo.exito && resultadoSegundo.data.length > 0) {
                console.log(`✅ Después de crear ejemplos: ${resultadoSegundo.data.length} registros`);
                return {
                  exito: true,
                  data: resultadoSegundo.data,
                  fuente: 'api_con_ejemplos',
                  total: resultadoSegundo.data.length
                };
              }
            }
          }
          
          // Sincronizar con localStorage si hay datos nuevos
          if (resultado.data.length > 0) {
            const asistenciasLocal = obtenerAsistenciasLocal();
            const nuevosRegistros = resultado.data.filter(apiRecord => 
              !asistenciasLocal.some(localRecord => 
                localRecord.Id === apiRecord.Id || 
                (localRecord.IdTaller === apiRecord.IdTaller && 
                 localRecord.IdGrupo === apiRecord.IdGrupo && 
                 localRecord.IdAlumno === apiRecord.IdAlumno &&
                 localRecord.Fecha === apiRecord.Fecha)
              )
            );
            
            if (nuevosRegistros.length > 0) {
              const todosLosRegistros = [...asistenciasLocal, ...nuevosRegistros];
              guardarAsistenciasLocal(todosLosRegistros);
              console.log(`🔄 Sincronizados ${nuevosRegistros.length} nuevos registros en localStorage`);
            }
          }
          
          return {
            exito: true,
            data: resultado.data,
            fuente: 'api',
            total: resultado.data.length
          };
        }
      } else {
        // Manejar errores HTTP específicos
        console.error(`❌ Error HTTP ${response.status}: ${response.statusText}`);
        
        // Intentar obtener el mensaje de error del servidor
        try {
          const errorData = await response.json();
          console.error('❌ Error del servidor:', errorData);
        } catch (parseError) {
          console.error('❌ No se pudo parsear el error del servidor:', parseError);
        }
        
        // Lanzar excepción para que sea capturada por el catch
        throw new Error(`API Error ${response.status}: ${response.statusText}`);
      }
      
      console.log('⚠️ API no devolvió datos válidos, usando localStorage...');
      
    } catch (apiError) {
      console.warn('❌ Error en API:', apiError.message);
      
      // Verificar si es un error de base de datos específico
      if (apiError.message.includes('Invalid column name') || apiError.message.includes('IdAlumno')) {
        console.warn('🚫 Error de estructura de base de datos detectado. La tabla no tiene la estructura esperada.');
        console.warn('💡 Recomendación: Ejecutar los scripts SQL para crear/actualizar la tabla de asistencia.');
      }
      
      console.log('🔄 Fallback a localStorage debido a error en API...');
    }
    
    // 2. BACKUP: Consultar localStorage
    console.log('📦 Consultando localStorage como backup...');
    let asistenciasLocal = obtenerAsistenciasLocal();
    console.log(`📦 Datos en localStorage: ${asistenciasLocal.length} registros`);
    
    // Si localStorage está completamente vacío, crear datos de ejemplo
    if (asistenciasLocal.length === 0) {
      console.log('📭 No hay datos en localStorage ni en la API');
      console.log('✨ Creando datos de ejemplo en localStorage...');
      
      const datosEjemplo = [
        {
          Id: 1,
          IdTaller: 10,
          IdGrupo: 15,
          IdAlumno: 101,
          Estado: 'presente',
          Fecha: '2026-01-16T10:00:00',
          Observaciones: 'Asistencia completa',
          FechaRegistro: new Date().toISOString()
        },
        {
          Id: 2,
          IdTaller: 10,
          IdGrupo: 15,
          IdAlumno: 102,
          Estado: 'ausente',
          Fecha: '2026-01-16T10:00:00',
          Observaciones: 'Sin justificación',
          FechaRegistro: new Date().toISOString()
        },
        {
          Id: 3,
          IdTaller: 11,
          IdGrupo: 15,
          IdAlumno: 103,
          Estado: 'justificado',
          Fecha: '2026-01-15T10:00:00',
          Observaciones: 'Permiso médico',
          FechaRegistro: new Date().toISOString()
        },
        {
          Id: 4,
          IdTaller: 12,
          IdGrupo: 15,
          IdAlumno: 104,
          Estado: 'presente',
          Fecha: '2026-01-16T10:00:00',
          Observaciones: 'Participación activa',
          FechaRegistro: new Date().toISOString()
        },
        {
          Id: 5,
          IdTaller: 10,
          IdGrupo: 15,
          IdAlumno: 105,
          Estado: 'presente',
          Fecha: '2026-01-15T10:00:00',
          Observaciones: 'Excelente rendimiento',
          FechaRegistro: new Date().toISOString()
        }
      ];
      
      guardarAsistenciasLocal(datosEjemplo);
      asistenciasLocal = datosEjemplo;
      console.log(`✨ Creados ${datosEjemplo.length} registros de ejemplo`);
    }
    
    // Aplicar filtros a localStorage
    let filtradas = [...asistenciasLocal];
    
    if (filtros.idTaller) {
      filtradas = filtradas.filter(a => a.IdTaller == filtros.idTaller);
      console.log(`🎯 Filtro IdTaller=${filtros.idTaller}: ${filtradas.length} registros`);
    }
    
    if (filtros.idGrupo) {
      filtradas = filtradas.filter(a => a.IdGrupo == filtros.idGrupo);
      console.log(`🎯 Filtro IdGrupo=${filtros.idGrupo}: ${filtradas.length} registros`);
    }
    
    if (filtros.fecha) {
      const fechaFiltro = filtros.fecha.includes('T') ? filtros.fecha.split('T')[0] : filtros.fecha;
      filtradas = filtradas.filter(a => {
        if (!a.Fecha) return false;
        const fechaRegistro = a.Fecha.includes('T') ? a.Fecha.split('T')[0] : a.Fecha;
        return fechaRegistro === fechaFiltro;
      });
      console.log(`🎯 Filtro Fecha=${fechaFiltro}: ${filtradas.length} registros`);
    }
    
    if (filtros.estado) {
      filtradas = filtradas.filter(a => a.Estado?.toLowerCase() === filtros.estado.toLowerCase());
      console.log(`🎯 Filtro Estado=${filtros.estado}: ${filtradas.length} registros`);
    }
    
    console.log(`✅ Devolviendo ${filtradas.length} registros desde localStorage`);
    
    return {
      exito: true,
      data: filtradas,
      fuente: 'localStorage',
      total: filtradas.length
    };
    
  } catch (error) {
    console.error('❌ Error general al consultar asistencia:', error);
    
    // En caso de error total, intentar localStorage una vez más
    try {
      const asistenciasLocal = obtenerAsistenciasLocal();
      return {
        exito: true,
        data: asistenciasLocal,
        fuente: 'error_recovery',
        error: error.message,
        total: asistenciasLocal.length
      };
    } catch (recoveryError) {
      return {
        exito: false,
        data: [],
        fuente: 'error',
        error: error.message,
        total: 0
      };
    }
  }
}

// Resumen de asistencia por grupo
export async function resumenAsistenciaGrupo(filtros = {}) {
  try {
    const params = new URLSearchParams();
    
    if (filtros.idTaller) params.append('idTaller', filtros.idTaller);
    if (filtros.idGrupo) params.append('idGrupo', filtros.idGrupo);
    if (filtros.fechaInicio) params.append('fechaInicio', filtros.fechaInicio);
    if (filtros.fechaFin) params.append('fechaFin', filtros.fechaFin);
    
    const queryString = params.toString();
    const endpoint = queryString ? `/asistencia/resumen-grupo?${queryString}` : '/asistencia/resumen-grupo';
    
    const response = await apiFetch(endpoint);
    return await response.json();
  } catch (error) {
    console.error('Error al obtener resumen de asistencia:', error);
    throw error;
  }
}

// Eliminar/desactivar asistencia
export async function eliminarAsistencia(id) {
  try {
    const response = await apiFetch(`/asistencia/${id}`, {
      method: 'DELETE'
    });
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar asistencia:', error);
    throw error;
  }
}

// Crear datos de ejemplo en la API
async function crearDatosEjemplo() {
  try {
    console.log('🎯 Creando datos de ejemplo via API...');
    
    const datosEjemplo = {
      IdTaller: 10,
      IdGrupo: 15,
      IdMaestro: 1,
      Fecha: '2026-01-16',
      Asistencias: [
        { IdAlumno: 101, Estado: 'presente', Observaciones: 'Asistencia completa' },
        { IdAlumno: 102, Estado: 'ausente', Observaciones: 'Sin justificación' },
        { IdAlumno: 103, Estado: 'justificado', Observaciones: 'Permiso médico' },
        { IdAlumno: 104, Estado: 'presente', Observaciones: 'Participación activa' },
        { IdAlumno: 105, Estado: 'presente', Observaciones: 'Excelente rendimiento' }
      ]
    };
    
    const response = await apiFetch('/asistencia/guardar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datosEjemplo)
    });
    
    if (response.ok) {
      const resultado = await response.json();
      console.log('✅ Datos de ejemplo creados via API:', resultado);
      return resultado;
    } else {
      console.warn('⚠️ No se pudieron crear datos via API');
      return null;
    }
    
  } catch (error) {
    console.warn('❌ Error creando datos de ejemplo:', error);
    return null;
  }
}

// Test de conexión con la API de asistencia
export async function testConexionAsistencia() {
  try {
    const response = await apiFetch('/asistencia/test');
    return await response.json();
  } catch (error) {
    console.error('Error en test de conexión:', error);
    throw error;
  }
}

// Consulta simplificada sin filtros para testing
export async function consultarAsistenciaSimple() {
  try {
    console.log('🔍 Consultando asistencia sin filtros...');
    
    const response = await apiFetch('/asistencia/consultar');
    
    if (response.ok) {
      const resultado = await response.json();
      console.log('✅ Consulta simple exitosa:', resultado);
      return resultado;
    } else {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
  } catch (error) {
    console.error('❌ Error en consulta simple:', error);
    throw error;
  }
}
